import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';
import PlayerLink from 'components/PlayerLink';
import RolloverController from 'components/RolloverController';
import ResultRollover from 'components/ResultRollover';
import { Table, Th, Td } from 'components/Table';

export default class BattingRunChasePage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { rows } = this.props;
        return (
            <Main>
                <MainHeader />
                <Body id="batting-run-chase-page">
                    <Panel border>
                        <PanelTop title="Batting Run Chase" buttons />
                        <BattingRunChaseTable rows={rows} />
                    </Panel>
                </Body>
            </Main>
        );
    }
}

const BattingRunChaseTable = ({ rows }) => {
    const maxRuns = rows.length > 0 ? rows[0].runs : 0;
    return (
        <Table>
            <thead>
                <tr>
                    <Th min="4" />
                    <Th min="4" left>
                        Name
                    </Th>
                    <Th min="4" short="2" value="Inns">
                        Innings
                    </Th>
                    <Th min="4">Runs</Th>
                    <Th priority="2" left>
                        Chase
                    </Th>
                </tr>
            </thead>
            <tbody>{rows.map((row, index) => <BattingRunChaseRow key={row.pid} index={index} row={row} maxRuns={maxRuns} />)}</tbody>
        </Table>
    );
};

const numColours = 60;
const lowColours = [];
const highColours = [];

for (let i = 0; i < numColours; i += 1) {
    lowColours.push(`hsl(${(i * 42) % 360}, 30%, 70%)`);
    highColours.push(`hsl(${(i * 42) % 360}, 80%, 50%)`);
}

const BattingRunChaseRow = ({ row, index, maxRuns }) => (
    <tr className="cc-chase-row">
        <Td min="4">{index + 1}</Td>
        <Td min="4" left>
            <PlayerLink pid={row.pid} fname={row.fname} lname={row.lname} />
        </Td>
        <Td min="4">{row.innings.length}</Td>
        <Td min="4">{row.runs}</Td>
        <Td priority="2" left>
            {row.innings.map(match => <BattingRunChaseMatch key={match.mid} maxRuns={maxRuns} match={match} />)}
        </Td>
    </tr>
);

class BattingRunChaseMatch extends React.Component {
    constructor(props) {
        super(props);
        this.controller = new RolloverController(this, 'bottom', 400);
        this.state = this.controller.getInitialState();
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    onMouseEnter() {
        this.controller.onMouseEnter(`/api/results/${this.props.match.mid}/summary`);
    }

    onMouseLeave() {
        this.controller.onMouseLeave();
    }

    render() {
        const { match, maxRuns } = this.props;
        const style = {
            width: `${100 * (match.runs / maxRuns)}%`,
            backgroundColor: match.runs >= 50 ? highColours[match.mid % numColours] : lowColours[match.mid % numColours]
        };
        let label;
        let rollover;
        if (this.state.rollover) {
            const labelStyle = {
                backgroundColor: style.backgroundColor
            };
            let labelClassName = 'cc-chase-bar-label';
            if (this.controller.directionInfo && this.controller.directionInfo.slideLeft) {
                labelClassName += ' cc-text-right';
            }
            label = (
                <div className={labelClassName} style={labelStyle}>
                    {match.runs}
                    {match.isout === 'NOT OUT' ? '*' : ''} runs
                </div>
            );
            rollover = (
                <ResultRollover
                    mid={match.mid}
                    data={this.state.data}
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                    directionInfo={this.controller.directionInfo}
                />
            );
        }
        return (
            <div ref="element" className="cc-chase-bar" style={style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {label}
                <div className="cc-rollover-wrapper">{rollover}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/batting-run-chase/BattingRunChasePage.jsx